import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { PhotoProvider } from 'react-photo-view';
import { useDialogs } from '../../../../../hooks';
import Card from './Card';

const PhotoGallery = ({
  currentSiteImages = [],
  setCurrentSiteImages = () => {},
  siteId = null,
  onRemoveImage,
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  // Handle cover photo
  const onSetPrimaryImage = (imageId) => {
    if (siteId) {
      const currentIndex = currentSiteImages.findIndex((img) => img.id === imageId);
      if (currentIndex === -1) return;
      const newImages = Array.from(currentSiteImages);
      const [movedImage] = newImages.splice(currentIndex, 1);
      newImages.unshift(movedImage);
      setCurrentSiteImages(newImages.map((img, index) => ({ ...img, position: index })));
    }
  };

  // Fallback removal if no onRemoveImage prop is provided.
  const defaultRemoveImage = (imageId) => {
    const imageIndex = currentSiteImages.findIndex((img) => img.id === imageId);
    if (imageIndex === -1) return;
    const newImages = currentSiteImages.filter((img) => img.id !== imageId);
    setCurrentSiteImages(newImages);
  };

  const { openDialog, closeDialog } = useDialogs();
  const getActionItems = (imageId) => [
    { label: 'Make cover photo', onClick: () => { onSetPrimaryImage(imageId); } },
    {
      label: 'Delete',
      onClick: () => {
        openDialog({
          message: 'Are you sure you want to remove this image?',
          show: true,
          actions: [
            {
              label: 'Cancel',
              variant: 'secondary',
              onClick: closeDialog,
            },
            {
              label: 'Remove',
              variant: 'primary',
              onClick: () => {
                // Look up the image object from currentSiteImages.
                const imageToRemove = currentSiteImages.find((img) => img.id === imageId);
                if (onRemoveImage && imageToRemove) {
                  onRemoveImage(imageToRemove);
                } else {
                  defaultRemoveImage(imageId);
                }
                closeDialog();
              },
            },
          ],
        });
      },
    },
  ];

  if (!currentSiteImages?.length) {
    return <></>;
  }
  return (
    <PhotoProvider>
      <div className="flex flex-wrap gap-y-5.5 gap-x-5.5 justify-start">
        {currentSiteImages.map((img, index) => (
          <Card
            key={img.id}
            img={img}
            index={index}
            siteId={siteId}
            openIndex={openIndex}
            setOpenIndex={setOpenIndex}
            getActionItems={getActionItems}
          />
        ))}
      </div>
    </PhotoProvider>
  );
};

PhotoGallery.propTypes = {
  currentSiteImages: PropTypes.array,
  siteId: PropTypes.number,
  setCurrentSiteImages: PropTypes.func,
  onRemoveImage: PropTypes.func,
};

export default PhotoGallery;
